import MorePopover from '@/components/ui/MorePopover';
import { useNavigate } from 'react-router';

import type { Machine } from '@/types';

type Props = {
  machine: Machine;
};

const RestockingMachineDotsMenu = ({ machine: { id } }: Props) => {
  const navigate = useNavigate();
  const items = [{ label: 'Create Load Order', disabled: false }];
  const handleClick = (_: number) => navigate(`/restocking/load-orders/new?id=${id}`);
  return <MorePopover onClick={handleClick} items={items} />;
};

export default RestockingMachineDotsMenu;
